/* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages */
// Not a good idea to use experiment prefix in potentially long-lasting i18n strings
import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	makeTeamEffort: {
		id: 'live-docs-spotlight-nudge.makeTeamEffort',
		defaultMessage: 'Make it a team effort',
		description: 'Heading for spotlight that highlights share button',
	},
	shareDoc: {
		id: 'live-docs-spotlight-nudge.shareDoc',
		defaultMessage: 'Share this doc to start collaborating with your teammates',
		description: 'Body text for spotlight that highlights share functionality',
	},
	letsGo: {
		id: 'live-docs-spotlight-nudge.letsGo',
		defaultMessage: "Let's go",
		description: 'Text for the button to dismiss the "Lets go" button spotlight',
	},
});
